import type { StepType } from '@reactour/tour';
import type { TourStepContext } from './types';

export const homeSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="home-portfolio-card"]',
    content:
      'Este é o Painel Principal do seu portfólio. Aqui você vê um resumo rápido de todos os projetos ativos, o índice de saúde geral e os itens que precisam da sua atenção agora.',
  },
  {
    selector: '[data-tour="home-new-project-btn"]',
    content:
      'Clique aqui para criar um novo projeto e adicioná-lo ao portfólio. Você precisará preencher as informações básicas como nome, responsável e prazo.',
  },
  {
    selector: '#home-focus-tabs',
    content:
      'Esta área mostra o "Foco da semana": projetos com riscos abertos, sem atualização recente ou com problemas de disciplina. Use estas abas para priorizar sua agenda.',
  },
  {
    selector: '[data-tour="home-kpi-grid"]',
    content:
      'Os KPIs do portfólio mostram métricas agregadas em tempo real: projetos no prazo, orçamento total, riscos críticos e progresso médio. As setas indicam a tendência em relação à semana anterior.',
  },
  {
    selector: '[data-tour="ai-chat-button"]',
    content:
      'Este botão abre o Delfos em uma janela flutuante. Você pode alternar entre modo compacto e ampliado para consultar o contexto da página sem sair do fluxo.',
  },
];
